import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
// import BranchCard from './branch-card'
import loadable from '@loadable/component'
import { removeSlashFromSlug } from '../utils/additionalFunctions';


const Button = loadable(() => import('./basic-components/button'))
const BranchCard = loadable(() => import('./branch-card'))
const CarouselCard = loadable(() => import("./carousel-card"))
const CardImage2 = loadable(() => import("../assets/img/pexels-karolina-grabowska-5978712.jpg"))





const Branches = ({branchList, title,  sectionStyle="white"}) => {

    const data = useStaticQuery(graphql`
    {
      allStrapiSecondaryPages(filter: {slug: {eq: "about-us"}}) {
        edges {
          node {
            PageComponents
          }
        }
      }


      allStrapiBranches {
        edges {
          node {
            BranchName          
            Header {
              Background {
                localFile {
                  childImageSharp {
                    fluid{
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  `)


  
  
  const sectionClassName = sectionStyle =="white" ? "white-section" : "dark-section";

    return (
      <section className={sectionClassName + " padding-top padding-bottom"}>
       {/* <div  className='branch_container padding-top  padding-bottom margin-top'> */}
      <div className="carousel-section-wrapper">
        {title != null && title != "" ?<h2>{title}</h2> : '' }        

        {/* <p className="carousel-description">{description}</p> */}

      {/* <div className='lateral-padding'>
        <div className="uk-position-relative uk-visible-toggle uk-light" data-tabindex="-1" data-uk-slider>

          <ul className="uk-slider-items uk-child-width-1-1 uk-child-width-1-3@s uk-child-width-1-5@m branch-slider-container">
            
              {
              branchList?  branchList.map((branchItem, index) => {
                
                const background = data.allStrapiBranches.edges.find((secondaryItem) => {
                return secondaryItem.node.BranchName === branchItem.BranchName
                })

              
                return <li className={`branch-card${index}`} key={index} ><BranchCard  slug={branchItem.BranchSlug} {...background} index={index}/></li> 
                  
                

              }) : ''
              }     
          </ul>

          <span className="  left-arrow"  data-uk-slidenav-previous data-uk-slider-item="previous"></span>
          <span className="right-arrow" data-uk-slidenav-next data-uk-slider-item="next"></span>

          </div>
      </div> */}
      


      <div class="custom-slider-container" data-uk-slider>

          <div class="uk-position-relative uk-visible-toggle uk-light custom-slider" tabindex="-1" >
              <ul class="uk-slider-items uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@l carousel-container">
              {
              branchList?  branchList.map((item, index) => {

                  const background = data.allStrapiBranches.edges.find((secondaryItem) => {
                    var secondaryItemBranchSlug = removeSlashFromSlug(secondaryItem.node.BranchName);
                    const itemBranchSlug = (item.BranchSlug).replace('/branch/', '').replace('branch/', '');
                    if(secondaryItemBranchSlug === removeSlashFromSlug(itemBranchSlug)){
                      return secondaryItem;
                    }
                    return null;
                  })

                  if(background == null){
                    return('');
                  }
                  const itemBranch = {...background};
                  if(itemBranch.node?.Header.Background.localFile == null){
                    return('');
                  }
                  const image = itemBranch.node?.Header.Background.localFile.childImageSharp.fluid
                  const src = itemBranch.node?.Header.Background.localFile.publicURL

                  return <li className={`branch-card${index}`} key={index}>
                          
                          <CarouselCard 
                              key={index}
                              //andrei: localFile or childimageSharp can be empty and it breaks the build
                              img={src}
                              title={item.BranchName}
                              description={""}
                              price={null}
                              // linkLabel={"View Product"}
                              linkUrl={removeSlashFromSlug(item.BranchSlug)}
                              component={'news'}
                              index={index}
                              ignoreLowerCase={true}
                              >
                              
                          </CarouselCard>
                          
                  
                  </li> 

                  }): ''
                  }
              </ul>
              
          </div>

          <a class="uk-position-center-left  slider-nav prev" href="#" data-uk-slidenav-previous data-uk-slider-item="previous">
              <svg width="25" height="50" viewBox="0 0 25 50" xmlns="http://www.w3.org/2000/svg">
                  <polyline fill="none" stroke="#000" stroke-width="2" points="20.527,-10 2,20.024 20.525,50 "></polyline>
              </svg>
          </a>
          <a class="uk-position-center-right  slider-nav next" href="#" data-uk-slidenav-next data-uk-slider-item="next">
              <svg width="25" height="50" viewBox="0 0 25 50" xmlns="http://www.w3.org/2000/svg">
                  <polyline fill="none" stroke="#000" stroke-width="2" points="4.002,50 20.527,20.024 4,-10 "></polyline>
              </svg>
          </a>
          
      </div>
  
      

        <div className='redirect-container lateral-padding'>
          <Link to='/our-branches' className='redirect-branches'>
            <Button label="See all branches" use="" />
          </Link>
        </div>

     
      
      </div>
      </section>
    )  
}





export default Branches